// @ts-nocheck
/* eslint-disable */
export const spaceConfigIcon = {
        data: `<svg
    class="management-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

    <path
        d="M69.7548 35.1698C69.5948 35.0348 69.3947 34.9748 69.1847 35.0098L50.0024 38.1052L30.8201 35.0098C30.6051 34.9748 30.405 35.0348 30.25 35.1698C30.09 35.3048 30 35.4999 30 35.7099V55.3672C30 55.3973 30.015 55.4173 30.02 55.4473C30.025 55.5123 30.035 55.5723 30.06 55.6273C30.075 55.6623 30.095 55.6923 30.115 55.7273C30.145 55.7773 30.175 55.8223 30.22 55.8623C30.235 55.8723 30.24 55.8923 30.25 55.9023C30.275 55.9223 30.31 55.9373 30.34 55.9523C30.36 55.9673 30.375 55.9873 30.395 55.9973L49.6874 65.5835C49.7874 65.6335 49.8974 65.6585 50.0024 65.6585C50.1074 65.6585 50.2174 65.6335 50.3174 65.5835L69.6098 55.9973C69.6298 55.9873 69.6448 55.9673 69.6648 55.9523C69.6948 55.9323 69.7248 55.9223 69.7548 55.9023C69.7698 55.8923 69.7748 55.8723 69.7848 55.8623C69.8248 55.8223 69.8598 55.7773 69.8898 55.7273C69.9098 55.6923 69.9298 55.6623 69.9448 55.6273C69.9698 55.5673 69.9798 55.5073 69.9848 55.4473C69.9898 55.4223 69.9998 55.3973 69.9998 55.3672V35.7099C70.0048 35.4999 69.9148 35.3048 69.7548 35.1698ZM31.4152 36.54L49.2923 39.4253V51.6468L44.4117 52.4369V42.9421C44.4117 42.5521 44.0967 42.232 43.7016 42.232L36.9958 41.4656C36.6058 41.4656 36.2858 41.7806 36.2858 42.1757V53.7521L31.4152 54.5371V36.54ZM42.9966 43.6522V52.6669L37.7009 53.522V42.8857L42.9966 43.6522ZM50.0024 64.1633L33.0004 55.7173L50.0024 52.972L67.0044 55.7173L50.0024 64.1633ZM68.5896 54.5371L50.7125 51.6518V39.4253L68.5896 36.54V54.5371Z"
        fill="var(--icon-text)"
        stroke="var(--icon-text)"
        stroke-width="0.25" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>
`,
name: 'space-config' as const
};